module.exports = function() {
  this.plugin(
    [
      require('./util/pattern'),
      require('./util/range'),
      require('./util/required'),
      require('./util/type')
    ]
  )
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/util.js
// module id = 1381
// module chunks = 93